import { render, staticRenderFns } from "./ReviewSessionDetails.vue?vue&type=template&id=1c817683&scoped=true"
import script from "./ReviewSessionDetails.vue?vue&type=script&lang=js"
export * from "./ReviewSessionDetails.vue?vue&type=script&lang=js"
import style0 from "./ReviewSessionDetails.vue?vue&type=style&index=0&id=1c817683&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c817683",
  null
  
)

export default component.exports